export default __webpack_public_path__ + "static/media/support-rapidminer.86e125f8.yaml";